module.exports = __webpack_public_path__ + "img/img (48).52209854.jpg";